import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertCircle } from 'lucide-react';

interface ErrorMessageProps {
  message: string;
  title?: string;
  variant?: 'inline' | 'block';
}

export default function ErrorMessage({ 
  message, 
  title,
  variant = 'block' 
}: ErrorMessageProps) {
  const { t } = useTranslation('common');

  if (variant === 'inline') {
    return (
      <div className="flex items-center mt-2 text-sm text-red-600">
        <AlertCircle className="w-4 h-4 flex-shrink-0 mr-2" />
        <span>{message}</span>
      </div>
    );
  }

  return (
    <div className="rounded-lg bg-red-50 p-4 border border-red-100">
      <div className="flex">
        <AlertCircle className="h-5 w-5 text-red-400" />
        <div className="ml-3">
          <h3 className="text-sm font-medium text-red-800">
            {title || t('validation.error')}
          </h3>
          <div className="mt-2 text-sm text-red-700">
            {message}
          </div>
        </div>
      </div>
    </div>
  );
}